import { ref, computed, onMounted, onUnmounted } from '@vue/composition-api'

export default function useDeviceDetection () {
  const screenWidth = ref(window.screen.width)

  const isMobile = computed(() => {
    return screenWidth.value <= 480
  })

  const isDesktop = computed(() => {
    return !isMobile.value
  })

  const updateScreenWidth = () => {
    screenWidth.value = window.screen.width
  }

  // Listen for screen size changes (optional, for dynamic updates)
  onMounted(() => {
    window.addEventListener('resize', updateScreenWidth)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', updateScreenWidth)
  })

  return {
    isMobile,
    isDesktop,
    screenWidth
  }
}



// WEBPACK FOOTER //
// ./src/app/authentication/compositions/UseDeviceDetection.js